import { BoxProps, TextNewProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

const DefaultStyle = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    backgroundColor: 'WHITE',
    padding: 16,
    marginHorizontal: 18,
    border: `1px solid ${Colors.SECONDARY_GREY}`,
    justifyContent: 'space-between',
    borderRadius: 4,
    position: 'relative',
    flexGrow: 1,
  } as BoxProps,
  tableContainer: (isLoading: boolean) =>
    ({
      alignContent: 'center',
      flexGrow: 1,
      marginTop: isLoading ? 24 : undefined,
    } as ViewStyle),
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as ViewStyle,
}

const styles = (breakpoint: number): any => {
  const isMobile = breakpoint < 560
  const isExtraaSmall = breakpoint <= 320

  return {
    scrollContainer: {
      flexGrow: 1,
    },
    maincontainer: {
      margin: isMobile ? 0 : 16,
      flex: 1,
      backgroundColor: 'BACKGROUND',
    } as BoxProps,
    mainContainerWeb: {
      marginHorizontal: 16,
      overflow: 'auto',
      maxHeight: '80vh',
      position: 'relative',
      marginTop: 16,
      paddingBottom: 40,
    } as BoxProps,
    aligncenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      paddingBottom: 16,
      margin: 16,
    } as BoxProps,
    tabbar: {
      backgroundColor: 'white',
      marginTop: 20,
      paddingLeft: 16,
      marginRight: 'auto',
      width: '100%',
      height: 48,
    } as ViewStyle,
    transactions: {
      ...DefaultStyle,
    },
    settlements: {
      ...DefaultStyle,
    },
    'settlements-reporting': {
      ...DefaultStyle,
    },
    'settlements-add-update': {
      ...DefaultStyle,
    },
    refunds: {
      ...DefaultStyle,
    },
    disputes: {
      ...DefaultStyle,
    },
    topBar: {
      flexDirection: 'row',
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      zIndex: 12,
      // flex: 1,
      flexWrap: 'wrap',
    } as BoxProps,
    mobileSelectionFix: {
      marginRight: isMobile ? 10 : 0,
      display: 'flex',
      borderWidth: 1,
      flex: 1,
      flexWrap: 'wrap',
      flexDirection: 'row',
      borderColor: 'TRANSPARENT',
    } as BoxProps,
    popupFieldSettings: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.MODAL_SHADOW,
      zIndex: 1,
    } as ViewStyle,
    stickyHeader: {
      position: 'sticky',
      paddingVertical: 8,
      pl: 12,
    } as BoxProps,
    popupBody: {
      borderColor: Colors.WHITE,
      backgroundColor: Colors.WHITE,
      shadowOpacity: 0.6,
      shadowRadius: 5,
      borderRadius: 8,
    } as ViewStyle,
    refundBody: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
    } as ViewStyle,
    errorView: {
      textAlign: 'center',
      margin: 8,
      color: 'RED',
    } as TextProps,
    loadingView: { width: '100%', textAlign: 'center' } as TextProps,
    hoverlistHeaderContainer: {
      flex: 1,
      flexDirection: 'row',
      // Todo
      backgroundColor: '#F8F8F8',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,

    listItemContainer: {
      flex: 1,
      flexDirection: 'row',
      paddingTop: 16,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,

    listItemText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 12,
      fontWeight: 'MEDIUM',
      color: 'BLACK_21',
      paddingRight: 16,
    } as TextProps,
    dateSelectorContainer: {
      flexDirection: 'row',
      marginTop: 20,
      flexWrap: 'wrap',
      maxWidth: '100%',
      justifyContent: 'flex-start',
    } as BoxProps,
    hoverHeaderText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 10,
      fontWeight: 'MEDIUM',
      color: 'PRIMARY_GREY',
      paddingRight: 16,
    } as TextProps,
    container: {
      shadowColor: Colors.BLACK,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.4,
      shadowRadius: 8,
      elevation: 5,
      overflow: 'hidden',
      borderRadius: 4,
      flex: 1,
      backgroundColor: Colors.WHITE,
      borderWidth: 1,
      borderColor: Colors.BORDER_COLOR,
    } as ViewStyle,
    textLayout: {
      flex: 1,
      justifyContent: 'flex-start',
      flexDirection: 'row',
      padding: 0,
      margin: 0,
    } as ViewStyle,
    rowContainer: {
      flexDirection: 'row',
      marginTop: 20,
      minWidth: isMobile ? '100%' : 10,
      maxWidth: '100%',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    } as BoxProps,
    generateContainer: {
      marginTop: isMobile ? 24 : 0,
      minHeight: 36,
    } as BoxProps,
    hoverHeader: {
      padding: 24,
    } as ViewStyle,
    hoverDetails: {
      flex: 1,
      flexDirection: 'row',
      margin: 24,
      padding: 0,
    } as ViewStyle,
    hoverColumn: {
      flex: 1,
      flexDirection: 'column',
      margin: 0,
      padding: 0,
    } as ViewStyle,
    modalList: {
      backgroundColor: 'WHITE',
      position: 'relative',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    } as BoxProps,
    modalListItem: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: 20,
      paddingVertical: 20,
      borderBottomWidth: 1,
      borderBottomColor: 'GREY_SEPARATOR',
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    bars: {
      backgroundColor: 'WHITE',
      padding: 8,
      marginTop: isExtraaSmall ? 20 : 0,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: Colors.LIGHT_GREY,
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
    buttonContainer: {
      paddingHorizontal: 10,
      paddingVertical: 10,
    } as BoxProps,
    settlmentNote: {
      marginLeft: 16,
    } as BoxProps,
    addReportButton: {
      borderRadius: 4,
      ph: 16,
      pv: 8,
      w: 176,
      h: 40,
      backgroundColor: Colors.REPORT_PRIMARY,
      underlayColor: 'BLUE',
      alignItems: 'center',
      justifyContent: 'center',
    } as BoxProps,
    titleText: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: 'jiotype-bold',
      color: 'BLACK_75',
    } as TextNewProps,
  }
}

export default styles
